// extracted by mini-css-extract-plugin
export default {"table":"Table-module__table___zcm4_","th":"Table-module__th___dq_wI","td":"Table-module__td___QnVVh","tr":"Table-module__tr___acxBE"};